import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { RetailAppModule } from 'retail/app/retail-app.module';
import { environment } from 'retail/environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(RetailAppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.error(err));
